module.exports = __webpack_public_path__ + "static/img/video-popup-bg-300x164.5f4d242.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/video-popup-bg-300x164.jpg
// module id = 3Jp2
// module chunks = 0